import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectLanguage from "~/components/SelectLanguage/SelectLanguage";
import localizationService from "~/services/LocalizationService";
import { EDIT_LOGGED_USER_SUCCESS } from "~/store/action_types";
import { editSystemLanguageAction } from "~/store/actions/actions.languages";
import { editLoggedUser } from "~/store/actions/actions.users";
import { getDefaultLanguage } from "~/store/selectors/selector.languages";
import { getLoggedUserId, makeGetLoggedUserLanguageIdSelector } from "~/store/selectors/selector.users";

export const LanguagePicker = () => {
  const dispatch = useDispatch();
  const loggedUserId = useSelector(getLoggedUserId);
  const getLoggedUserLanguageIdSelector = useMemo(() => makeGetLoggedUserLanguageIdSelector(), []);
  const languageId = useSelector(getLoggedUserLanguageIdSelector);
  const defaultLanguage = useSelector(getDefaultLanguage);

  const setLanguage = useCallback(
    (id) => {
      dispatch(editLoggedUser(loggedUserId, { language_id: id })).then((res) => {
        if (defaultLanguage && id !== defaultLanguage.id) {
          dispatch(editSystemLanguageAction(id));
        }

        if (res.type === EDIT_LOGGED_USER_SUCCESS && id) {
          localizationService.update({ language_id: id });
        }
      });
    },
    [defaultLanguage, dispatch, loggedUserId]
  );

  return (
    <SelectLanguage
      id="select-language"
      disableSearch
      mode="small"
      targetClassName="tw-w-full sm:tw-w-auto sm:tw-mt-0"
      onChange={setLanguage}
      selected={languageId}
      forceCloseMenu
    />
  );
};
